import React, {useEffect, useState} from 'react'
import {HistoriquePrixArgus} from './HistoriquePrixArgus'
import {updatePrixTarificationArgus} from "../../../../components/requests";
import {toast} from "react-toastify";

interface dataPrixArgusProps {
  dataPrixArgus?: any,
  setDataModifPrix?: any,
  modalDismissRef?: any
}

const PrixArgus = (
  {
    dataPrixArgus,
    setDataModifPrix,
    modalDismissRef
  }: dataPrixArgusProps
) => {
  const [dataPrix, setDataPrix] = useState<any>(dataPrixArgus)
  const [prixArgus, setPrixArgus] = useState<number>(Number(dataPrix?.nouveauPrix) ?? 0)

  useEffect(() => {
    setDataPrix(dataPrixArgus)
    setPrixArgus(Number(dataPrixArgus?.nouveauPrix) ?? 0)
  }, [dataPrixArgus ])

  const dataMetrique = JSON.parse(dataPrix?.metriques)

  let dataHistory: any = {}
  let variationArgusIm2 = ''
  let variationArgusIm3 = ''
  let prixArgusActuel = 0
  let prixArgusPrec1 = 0
  let prixArgusPrec2 = 0
  let prixArgusPrec3 = 0

  if (dataPrix?.history) {
    dataHistory = JSON.parse(dataPrix?.history)
    let prixByMonth = HistoriquePrixArgus(dataHistory) // fonction qui retourne les prix argus

    prixArgusActuel = Number(prixByMonth.prixM) // prix argus du mois actuel
    prixArgusPrec1 = Number(prixByMonth.prixM1) // prix argus du mois m-1
    prixArgusPrec2 = Number(prixByMonth.prixM2) // prix argus du mois m-2
    prixArgusPrec3 = Number(prixByMonth.prixM3) // prix argus du mois m-3

    //variation du prix argus du mois m-1 et le prix argus du mois m-2
    if (prixArgusPrec1 && prixArgusPrec2) {
      if (prixArgusPrec1 > prixArgusPrec2) {
        variationArgusIm2 = 'hausse'
      } else if (prixArgusPrec1 < prixArgusPrec2) {
        variationArgusIm2 = 'baisse'
      } else {
        variationArgusIm2 = 'stable'
      }
    }

    //variation du prix argus du mois m-2 et le prix argus du mois m-3
    if (prixArgusPrec2 && prixArgusPrec3) {
      if (prixArgusPrec2 > prixArgusPrec3) {
        variationArgusIm3 = 'hausse'
      } else if (prixArgusPrec2 < prixArgusPrec3) {
        variationArgusIm3 = 'baisse'
      } else {
        variationArgusIm3 = 'stable'
      }
    }
  }

  const updatePrix = (id: number, prix: number) => {
    const idToastValidate = toast.loading('Modification du prix en cours...')
    updatePrixTarificationArgus(id, prix)
      .then((res) => {
        if (res?.status === 200 && res?.data !== undefined) {
          setDataPrix((prev) => ({...prev, nouveauPrix: res?.data?.nouveauPrix}))
          setDataModifPrix((prev) => prev
            .map((dataPrix) => dataPrix?.id === id
              ? ({...dataPrix, nouveauPrix: res?.data?.nouveauPrix})
              : dataPrix
            )
          )
          toast.update(idToastValidate, {
            render: 'Modification du prix effectuée avec succès...',
            type: 'success',
            isLoading: false,
            autoClose: 3000,
          })
          modalDismissRef?.current?.click()
        }
      })
      .catch(() => {
        toast.update(idToastValidate, {
          render: 'Erreur durant la modification du prix...',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      })
  }

  return (
    <div className='d-flex mt-5 gap-3 h-200px'>
      <div className='col-md-3 d-flex justify-content-center align-items-center border-1 border border-secondary rounded-1'>
        <div className='d-flex gap-5'>
          <div>
            <span>Prix Argus m-2</span>
            <div className='border border-1 border-secondary h-50px text-center rounded-1 d-flex justify-content-center align-items-center'>
              {prixArgusPrec2.toFixed(2)} €
            </div>
            {variationArgusIm3 === 'hausse' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-up-right fs-1' style={{color: 'orange'}}></i>
              </span>
            )}
            {variationArgusIm3 === 'baisse' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-down-right fs-1' style={{color: 'red'}}></i>
              </span>
            )}
            {variationArgusIm3 === 'stable' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-right fs-1' style={{color: 'green'}}></i>
              </span>
            )}
          </div>
          <div>
            <span>Prix Argus m-1</span>
            <div className='border border-1 border-secondary h-50px text-center rounded-1 d-flex justify-content-center align-items-center'>
              {prixArgusPrec1.toFixed(2)} €
            </div>
            {variationArgusIm2 === 'hausse' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-up-right fs-1' style={{color: 'orange'}}></i>
              </span>
            )}
            {variationArgusIm2 === 'baisse' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-down-right fs-1' style={{color: 'red'}}></i>
              </span>
            )}
            {variationArgusIm2 === 'stable' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-right fs-1' style={{color: 'green'}}></i>
              </span>
            )}
          </div>
        </div>
      </div>
      <div className='col-md-6 border-1 border border-secondary rounded-1'>
        <div className='h-30px d-flex justify-content-start align-items-center bg-primary text-white'>
          <span>
            <i className='bi bi-tag text-white me-1 ms-3 fs-4'></i>
            Prix calculé
          </span>
        </div>
        <div className='text-center mt-5'>
          <span> {dataPrix?.nouveauPrix != null ? `${Number(dataPrix?.nouveauPrix)?.toFixed(2)} €` : '0'}</span>
          <br/>
          <span>Prix calculé</span>
          <div className='d-flex justify-content-center gap-4'>
            <button className='btn btn-info btn-sm' style={{cursor:'text'}}>{dataMetrique?.raison}</button>
            <button className='btn btn-secondary btn-sm' style={{cursor:'text'}}>
              {dataMetrique?.isMarche ? 'PRIX MARCHE' : 'LACOUR FIXE'}
            </button>
          </div>
        </div>

        {/* debut d'affichage de l'échelle du bloc au millieu */}
        <div className='m-5'>
          <div className='position-relative border border-1 rounded-1 h-20px bg-primary'>
            {/* Point */}
            <div
              className='position-absolute bg-dark rounded-circle'
              style={{
                width: '10px',
                height: '10px',
                top: '50%',
                left: '25%', // quart de la barre
                transform: 'translate(-50%, -50%)',
              }}
            >
              {/* Infobulle */}
              <div
                className='position-absolute text-white px-2 py-1 rounded'
                style={{
                  top: '-35px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontSize: '12px',
                  whiteSpace: 'nowrap',
                  backgroundColor: 'green',
                }}
              >
                ig:{' '}
                {dataMetrique?.indiceGlobal != null
                  ? `${dataMetrique?.indiceGlobal.toFixed(2)}`
                  : '0'}
              </div>
            </div>
          </div>

          <div className='d-flex justify-content-between mt-1'>
            <span>
              {dataMetrique?.prixMiniCouloir != null
                ? `${dataMetrique?.prixMiniCouloir.toFixed(2)} €`
                : ''}
            </span>
            <span>
              {dataMetrique?.prixMaxiCouloir != null
                ? `${dataMetrique?.prixMaxiCouloir.toFixed(2)} €`
                : ''}
            </span>
          </div>
        </div>
        {/* fin d'affichage de l'échelle du bloc au millieu */}
      </div>
      <div className='col-lg-3 d-flex justify-content-center align-items-center'>
        <div className='d-flex justify-content-between gap-5'>
          <div className='d-flex align-items-center'>
            {dataMetrique?.argus_type === 'mensuel' && (
              <button className='btn btn-info'>Argus Mensuel</button>
            )}
            {dataMetrique?.argus_type === 'quotidien' && (
              <button className='btn btn-info'>Argus Quotidien</button>
            )}
            {dataMetrique?.argus_type === 'manuel' && (
              <button className='btn btn-secondary'>Manuel</button>
            )}
          </div>
          {(dataPrix?.prixManuel === 0 && dataPrix?.traitee === 0) && (
            <div className="d-flex flex-column justify-content-between gap-2">
              <div
                className='border bg-light-success border-1 border-secondary h-50px text-center rounded-1 d-flex justify-content-center align-items-center'>
                <input
                  type='number'
                  min={0}
                  step={1}
                  value={prixArgus}
                  onChange={(e) => setPrixArgus(Number(e?.target?.value))}
                  className='w-50 border-0 text-center'
                  style={{background: 'none'}}
                />
              </div>
              <button
                type="button"
                className='btn btn-info'
                onClick={() => updatePrix(Number(dataPrix?.id), Number(prixArgus))}
              >
                Modifier le prix et l'argus
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export {PrixArgus}
